/* eslint-disable jsx-a11y/anchor-is-valid */
import clsx from 'clsx'
import React, {useEffect, useState} from 'react'
import {useThemeMode} from '../../layout/theme-mode/ThemeModeProvider'
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import {executeGet, executePost} from '../../../../configs/Kubuku'
import {DURASIBACA, JMLKOLEKSI, JMLPENGGUNA, KOTA} from '../../../../api'
import {getIdKecamatan, getIdKota, setIdKota} from './globalFilter'

type Props = {
  className?: string
}

interface OptionType {
  value: string
  label: string
}

export const Dropdown1 = ({className}: Props) => {
  const {mode} = useThemeMode()

  const initialSelectData = {options: []}
  const initialStartDate = new Date()
  const [selectDataKota, setSelectDataKota] = useState(initialSelectData)
  const [selectDataKecamatan, setSelectDataKecamatan] = useState(initialSelectData)
  const [tanggalAwal, setTanggalAwal] = useState(initialStartDate)

  useEffect(() => {
    const getDataKota = async () => {
      try {
        const response = await executeGet(KOTA)
        const dataKota = response?.data || []
        const mappedDataKota = dataKota.map((kota) => ({
          value: kota.id,
          label: kota.name,
        }))
        setSelectDataKota({options: mappedDataKota})
      } catch (error) {
        console.error('Error fetching data:', error)
      }
    }
    getDataKota()
  }, [])

  const handleReset = () => {
    setSelectDataKota(initialSelectData)
    setTanggalAwal(initialStartDate)
  }

  const handleKotaSelect = async (selectedOption: OptionType | null) => {
    try {
      if (selectedOption && selectedOption.value) {
        setIdKota(selectedOption.value)
        // Lakukan sesuatu dengan selectedOption.value di sini (jika diperlukan)
      } else {
        console.error('Nilai selectedOption tidak valid.')
      }
    } catch (error) {
      console.error('Error handling selected city:', error)
    }
  }

  const handleButtonClick = async () => {
    try {
      const selectedIdKota = getIdKota()
      const formData = new FormData()
      formData.append('id_kota', selectedIdKota)
      const response = await executePost(DURASIBACA, formData)

      console.log('Nilai idKota setelah diperbarui:', getIdKota())
    } catch (error) {
      console.error('Error handling button click:', error)
    }
  }
  return <></>
}
